import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ClientService } from 'src/app/core/services/client.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { IUser } from 'src/app/core/models/user.model';
import { NgForm } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { CustomerService } from 'src/app/core/services/customer.service';
import { UserService } from 'src/app/core/services/user.service';
import { IClientModel } from 'src/app/core/models/application.model';
import { ApplicationService } from 'src/app/core/services/application.service';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-invoice-item',
  templateUrl: './invoice-item.component.html',
  styleUrls: ['./invoice-item.component.css'],
})
export class InvoiceItemComponent implements OnInit {
  id: string;
  invoiceId: string;
  items: any;
  invoice: any = null;
  togglePay = false;
  page = 1;
  perPage = 10;
  isLoading = false;
  currentUser: IUser;
  toggleCsvInfo = false;
  allUsers: IUser[] = [];
  users: IUser[] = [];
  selectedUser = '';
  selectedUserId = '';
  isClientInvoice = false;
  clients: IClientModel[] = [];
  client: any;

  toggleNameOfClientInvoice:boolean;
  toggleGenerateCsvOptions:boolean;

  get lower() {
    return this.perPage * (this.page - 1) + 1;
  }

  get upper() {
    return Math.min(this.perPage * this.page, this.items.count);
  }

  constructor(
    private clientService: ClientService,
    private customerService: CustomerService,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private authService: AuthService,
    private translate: TranslateService,
    private userService: UserService,
    private applicationService: ApplicationService
  ) {}

  ngOnInit(): void {
    this.id =
      this.route.snapshot.params.customerId ||
      this.route.snapshot.params.clientId;
    this.invoiceId = this.route.snapshot.params.invoiceId;

    this.authService.LoggedinUser.subscribe((res) => {
      this.currentUser = res;
    });

    this.onLoadInvoice();

    if (this.route.snapshot.params.clientId) {
      this.loadUsers();
      this.isClientInvoice = true;
      this.loadClient();
    } else {
      this.loadClients();
    }
  }

  onLoadInvoice(userId?: string) {
    this.isLoading = true;

    this.route.snapshot.params.customerId
      ? this.loadInvoice(this.customerService)
      : this.loadInvoice(this.clientService, userId);
  }

  loadInvoice(service?: ClientService | CustomerService, userId?: string) {
    service.getInvoiceById(this.id, this.invoiceId).subscribe(
      (res) => {
        this.invoice = res;
      },
      (err) => {
        this.isLoading = false;
      }
    );

    this.loadInvoiceItems(service, userId);
  }

  loadInvoiceItems(service?: ClientService | CustomerService, userId?: string) {
    this.isLoading = true;

    service
      .getInvoiceItems(this.id, this.invoiceId, this.page, this.perPage, userId)
      .subscribe(
        (res) => {
          this.isLoading = false;

          this.items = res;

          this.items.results.forEach((item) => {
            item.featuresArray = item.features.map((feature) => {
              return feature.displayName;
            });
          });
        },
        (err) => {
          this.isLoading = false;
        }
      );
  }

  loadUsers() {
    this.userService.getByApplicationId(this.id).subscribe((res) => {
      this.allUsers = res;
    });
  }

  loadClients() {
    this.customerService.getApplications(this.id).subscribe(
      (res) => {
        this.clients = res;
      },
      (err) => {}
    );
  }

  loadClient() {
    this.applicationService
      .getById(this.id)
      .subscribe((res) => (this.client = res));
  }

  onPay() {
    this.togglePay = true;
  }

  payInvoice(form: NgForm) {
    this.togglePay = false;

    const amount = form.form.value.amount;
    const toPay =
      this.invoice.amount - this.invoice.credits - +this.invoice.paidAmount;

    if (!amount) {
      return;
    }

    if (amount < 0) {
      this.translate.get('errors.canNotEnterNegativeAmount').subscribe((text: string) => {
        this.toastr.error(text);
      });
      return;
    }

    if (amount > toPay) {
      this.translate
        .get('invoice.amountError', { toPay: toPay })
        .subscribe((text: string) => {
          this.toastr.error(text);
        });
      return false;
    }

    this.clientService.payInvoice(this.id, this.invoice.id, amount).subscribe(
      (res) => {
        this.loadInvoice(this.clientService);
        this.toastr.success('Success');
      },
      (err) => {
        switch (err.error.code) {
          case 4000039:
            this.translate
              .get('invoice.amountError', { toPay: toPay })
              .subscribe((text: string) => {
                this.toastr.error(text);
              });
            break;
        }
      }
    );
  }

  closeInvoice() {
    const service = this.route.snapshot.params.customerId
      ? this.customerService
      : this.clientService;

    service.closeInvoice(this.id, this.invoice.id).subscribe(
      (res) => {
        this.loadInvoice(service);
        this.togglePay = false;
        this.toastr.success('Success');
      },
      (err) => {
        this.togglePay = false;
      }
    );
  }

  changePerPage(event) {
    this.perPage = event.target.value;

    this.route.snapshot.params.customerId
      ? this.loadInvoiceItems(this.customerService)
      : this.loadInvoiceItems(this.clientService, this.selectedUserId);
  }

  jumpToPage(event: any) {
    this.page = event;

    this.route.snapshot.params.customerId
      ? this.loadInvoiceItems(this.customerService)
      : this.loadInvoiceItems(this.clientService, this.selectedUserId);
  }

  downloadFile() {
    this.isLoading = true;

    const file = this.invoice.csvLink;

    if(this.isClientInvoice) {
      this.toggleNameOfClientInvoice = true;
      this.isLoading = false;
    } else {
      saveAs(file, `${this.invoice.number}.csv`);
      this.isLoading = false;
    }

    /* const link = document.createElement("a");
    document.body.appendChild(link);
    link.style.cssText = 'display: none';
    link.href = file;
    link.download = "invoice-" + this.invoice.number;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    this.isLoading = false;
   */
    // delete link;
   

    // this.clientService.getInvoiceCSV(this.id, this.invoiceId)
    //   .subscribe(
    //     res => {
    //       var blob = new Blob([res], {type: 'text/csv' })
    //       saveAs(blob, `${this.invoiceId}.csv`);
    //       this.isLoading = false;
    //     }
    //   );
  }

 
  nameOfClientInvoice(form: NgForm) {
    const file = this.invoice.csvLink;
    this.isLoading = true;
    if(form.form.value.clientNameInclude) {
      saveAs(file, `${this.client.name}_${this.invoice.number}.csv`);
    } else {
      saveAs(file, `${this.invoice.number}.csv`);
    }

    this.isLoading = false;
    this.toggleNameOfClientInvoice = false;
  }

  generateCSV() {
    const service = this.route.snapshot.params.customerId
      ? this.customerService
      : this.clientService;

    if (
      service === this.clientService &&
      this.client.customInvoiceConfig?.columns?.length
    ) {
      this.toggleGenerateCsvOptions = true;
    } else {
      service.generateCSV(this.id, this.invoiceId).subscribe(
        (res) => {
          this.invoice.csvStatus = 'in_progress';
          this.toggleCsvInfo = true;
        },
        (err) => {
          this.toastr.error(err.message);
        }
      );
    }
  }

  clientCSVGenerate(form: NgForm) {
    if (!form.valid) {
      this.translate.get('errors.chooseAnOption').subscribe((text: string) => {
        this.toastr.error(text);
      });
      return;
    }
    let customInvoiceConfigEnable = form.form.value.customInvoiceConfigEnable;
    this.clientService
      .generateCSV(this.id, this.invoiceId, customInvoiceConfigEnable)
      .subscribe(
        (res) => {
          this.invoice.csvStatus = 'in_progress';
          this.toggleCsvInfo = true;
          this.toggleGenerateCsvOptions = false;
        },
        (err) => {
          this.toastr.error(err.message);
        }
      );
  }

  isPartialPaid(invoice): boolean {
    return +invoice.paidAmount !== 0 && !invoice.closed;
  }

  searchUsers(event) {
    let searchText: string = event.target.value.toLowerCase();

    this.users = this.allUsers.filter((user) => {
      const regex = new RegExp(`${searchText}`, 'gi');
      return (
        user.name?.toLowerCase().match(regex) ||
        user.email?.toLowerCase().match(regex)
      );
    });

    if (searchText.length === 0) {
      this.users = [];
      // if (this.selectedUserId) {
      //   this.onLoadInvoice();
      // }
      this.selectedUserId = '';
    }
  }

  onSearch(event) {
    let searchText: string = event.target.value.toLowerCase();

    if (!searchText) {
      this.onLoadInvoice();
    } else if (searchText) {
      const user = this.allUsers.find(
        (user) => user.email.toLowerCase() === searchText
      );

      if (user) {
        this.selectUser(user);
      }
    }
  }

  selectUser(user: IUser) {
    const input = document.querySelector('#users') as HTMLInputElement;
    input.value = user.name;
    this.selectedUser = '';
    this.selectedUser = user.name;
    this.selectedUserId = user.id;
    this.users = [];
    this.page = 1;
    this.onLoadInvoice(user.id);
  }

  showReason = false;
  reason = '';
  seeReason(item) {
    if (!['transfer', 'feature'].includes(item.type)) {
      return;
    }
    this.showReason = true;
    this.reason = item.text;

    if (item.type === 'transfer') {
      const id = this.reason.split(' ')[7];
      const client = this.clients.find((client) => client.id === id);
      const name = client ? client.name : id;

      const arr = this.reason.split(' ');
      arr[7] = name;
      this.reason = arr.join(' ');
    }
  }
}
